function writeConsoleWelcome () {
  if (typeof console === 'object' && console.log && typeof console.log === 'function') {
    const color = {
      green: 'color:#1bb978;font-size:11px;'
    }
    if (isUA('chrome') || isUA('edge')) {
      console.log(
        '%c   _____    _   _    ' +
        '\n  / ___ \\  | | |_|  ' +
        '\n | |   | | | |  _  __        __   ____    _____' +
        '\n | |   | | | | | | \\ \\      / /  / __ \\  /  ___|' +
        '\n | |   | | | | | |  \\ \\    / /  | |__| | | |' +
        '\n | |   | | | | | |   \\ \\  / /   |  ____| | |' +
        '\n | |___| | | | | |    \\ \\/ /    | |____  | |' +
        '\n  \\_____/  |_| |_|     \\__/      \\_____| |_|' +
        '\n           ' +
        '\n  Welcome Oliver!\n',
        color.green
      )
    } else {
      console.log(
        '   _____    _   _    ' +
        '\n  / ___ \\  | | |_|  ' +
        '\n | |   | | | |  _  __        __   ____    _____' +
        '\n | |   | | | | | | \\ \\      / /  / __ \\  /  ___|' +
        '\n | |   | | | | | |  \\ \\    / /  | |__| | | |' +
        '\n | |   | | | | | |   \\ \\  / /   |  ____| | |' +
        '\n | |___| | | | | |    \\ \\/ /    | |____  | |' +
        '\n  \\_____/  |_| |_|     \\__/      \\_____| |_|' +
        '\n           ' +
        '\n  Welcome Oliver!\n'
      )
    }
    console.log('\x3e \x3e \x3e http://www.stoneitgt.com\n')
  }
}
function isUA (userAgent) {
  return navigator.userAgent.toLowerCase().indexOf(userAgent) > -1
}

export default { writeConsoleWelcome }



// WEBPACK FOOTER //
// ./src/modules/welcome.js